import { render, staticRenderFns } from "./PropertiesPaymentPropertyListTable.vue?vue&type=template&id=763620ea"
import script from "./PropertiesPaymentPropertyListTable.vue?vue&type=script&lang=js"
export * from "./PropertiesPaymentPropertyListTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports